<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Реестр шаблонов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить шаблон</li>
        </ol>
    </nav>

    <div class="template-add_input">
        <div class="text-input-group">
            <div class="mb-4 input-field">
                <label class="form-label">Название письма <span class="color-red">*</span></label>
                <input v-model="emailName" type="text" class="form-control" placeholder="">
            </div>
        </div>

        <div class="mb-4 input-field">
            <label class="form-label">Тема письма <span class="color-red">*</span></label>
            <input v-model="emailSubject" type="text" class="form-control" placeholder="">
        </div>

        <div class="v-select-input">
            <div class="mb-4">
                <div class="form-label">Отправитель <span class="color-red">*</span></div>
                <v-select class="select"
                    v-model="sender"
                    :items="senders"
                    @update:modelValue="onChangeSender"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable>
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="v-select-input">
            <div class="mb-4">
                <div class="form-label">Тематика письма (шаблон)</div>
                <v-select class="select"
                    v-model="sample"
                    :items="samples"
                    @update:modelValue="onChangePattern"
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable>
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>
    </div>

    <div id="leter-add-controls" class="letter_construct" style="display:block">

        <TinyMCE
            :key="editorIndex"
            :init="editorConfig"
            v-model="content"
        />

        <div class="template-add-controls__control-buttons">
            <div class="left-side">
                <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить и выйти'" @btnClick="createTemplate"/>
                <a :href="route_back" id="cancelButton" class="btn btn-lg btn-outline-dark me-3">Отменить</a>
            </div>
        </div>
    </div>

    <Alert />
</template>

<script>
import '/tinymce/tinymce.min.js';
import '/tinymce/icons/default/icons.min.js';
import '/tinymce/themes/silver/theme.min.js';
import '/tinymce/models/dom/model.min.js';
import TinyMCE from '@tinymce/tinymce-vue';
import axios from 'axios';
import TemplatesLetters from '../../../../models/Mailings/TemplatesLetters';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';

export default {
    name: 'TemplateAddComponent',
    components: {
        Alert,
        TinyMCE,
        ConfirmBtn
    },
    props: {
        route_back: String,
        route_create: String,
        route_sender_list: String,
        tinymce_keys: [Object]
    },
    data: function () {
        return {
            body: '',
            emailName: '',
            emailSubject: '',
            header: '',
            footer: '',
            sender: null,
            sender_id: null,
            senders: [],
            sample: null,
            samples: ['Письмо об ошибке', 'Письмо о восстановлении', 'Письмо информирование'],
            document_base_url: '',
            content: '',
            editorInstance: null,
            editorIndex: 0,
            template: new TemplatesLetters({
                route_create: this.route_create
            }),
        };
    },

    computed: {
        editorConfig() {
            return {
                language: 'ru',
                base_url: '/tinymce',
                suffix: '.min',
                plugins: [
                    'image', 'autoresize', 'code', 'media', 'autolink',
                    'table', 'lists', 'preview', 'link'
                ],
                toolbar1:
                    'newdocument | insertfile undo redo | bold italic underline strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | cut copy paste link | numlist bullist | ' +
                    'tabulation outdent indent | image media | code | table styleselect formatselect fontselect fontsizeselect | ' +
                    'removeformat | preview',
                toolbar_mode: 'wrap',
                toolbar_sticky: false,
                min_height: 400,
                image_advtab: true,
                file_picker_types: 'file image media',
                default_link_target: '_blank',
                link_context_toolbar: true,
                relative_urls: false,
                remove_script_host: false,
                link_title: false,
                document_base_url: this.document_base_url,
                paste_as_text: false,
                paste_data_images: true,
                paste_merge_formats: false,
                valid_elements: '*[*]',
                paste_webkit_styles: 'all',
                content_style: 'body { max-width: 600px; margin: 0 auto; }',
                setup: (editor) => {
                    this.editorInstance = editor;
                    editor.ui.registry.addButton('tabulation', {
                        icon: 'chevron-right',
                        tooltip: 'Отступ строки',
                        onAction: () => {
                            editor.execCommand('mceInsertContent', false, '&nbsp;&nbsp;&nbsp;&nbsp;');
                        }
                    });
                },
                images_upload_handler: this.uploadFunction,
            };
        }
    },

    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        onChangePattern: async function (res) {
            if (res == 'Письмо об ошибке') {
                this.addErrorPattern();
            }
            else if (res == 'Письмо о восстановлении') {
                this.addRecoveryPattern();
            }
            else if (res == 'Письмо информирование') {
                this.addInfoPattern();
            }
        },
        onChangeSender: async function (id) {
            const sender = this.senders.find(item => item.id === id);
            this.sender_id = sender.id;
            this.header = sender.header;
            this.footer = sender.footer;
            this.addHeaderAndFooter();
        },
        getSenders: async function () {
            let senders = await axios.get(this.route_sender_list);
            this.senders = senders.data.items;
        },
        createTemplate: async function () {
            if (this.emailName === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название письма' });
                this.toggleLoading();
                return;
            }

            if (this.emailSubject === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите тему письма' });
                this.toggleLoading();
                return;
            }

            if (this.sender_id == null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите отправителя' });
                this.toggleLoading();
                return;
            }

            let formData = new FormData();
            let tinymce = document.querySelector('iframe');
            let editor = tinymce.contentDocument || tinymce.contentWindow.document;

            formData.append('email_name', this.emailName);
            formData.append('email_subject', this.emailSubject);
            formData.append('sender_id', this.sender_id);
            formData.append('body', `<div style="max-width: 600px; margin: 0 auto">${editor.getElementById('tinymce').innerHTML}</div>`);

            let result = await this.template.create(formData);

            if (result) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Ошибка при добавлении шаблона' });
                this.toggleLoading();
            }
        },
        uploadFunction:  function(blobInfo, success, failure) {
			return new Promise((resolve, reject) => {
				const FormRequest = new FormData();
				FormRequest.append('image', blobInfo.blob());
				let imgUrl = null;
				axios.post('/technical/letter-constructor/upload', FormRequest).then((res) => {
					if(res.data.status == 'ok') {
						imgUrl = res.data.url;
						resolve(imgUrl);
					}
				});
			})
		},

        addErrorPattern: function () {
            const content = '<h2 style="display: flex; align-items: center;"><img src="https://f.d-services.ru/web_assets/icon-error.png" alt="" style="max-width:100%;max-height:100%;vertical-align: middle;float: left"><strong style="max-width:600px;color:rgb(0, 0, 0);vertical-align: -webkit-baseline-middle;margin-left: 10px;">Заголовок</strong></h2><p>Введите текст</p>';
            if (this.editorInstance.getContent().includes('<div id="letterText">')) {
                let header = '<div id="header">';
                let letterText = '<div id="letterText">'
                let footer = '<div id="footer">';
                function escapeRegExp(string) {
                    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                }

                let regexLetterText = new RegExp(`${escapeRegExp(letterText)}(.*?)${escapeRegExp(footer)}`, 's');
                let newStr = this.editorInstance.getContent();
                this.editorInstance.setContent(newStr.replace(regexLetterText, `${escapeRegExp(letterText)} ${content} ${escapeRegExp('</div>')} ${escapeRegExp(footer)}`));
            } else {
                this.editorInstance.setContent(content);
            }
        },

        addRecoveryPattern: function () {
            const content = '<h2 style="display: flex; align-items: center;"><img src="https://f.d-services.ru/web_assets/icon-success.png" alt="" style="max-width:100%;max-height:100%;vertical-align: middle;float: left"><strong style="max-width:600px;color:rgb(0, 0, 0);vertical-align: -webkit-baseline-middle;margin-left: 10px;">Заголовок</strong></h2><p>Введите текст</p>';
            if (this.editorInstance.getContent().includes('<div id="letterText">')) {
                let header = '<div id="header">';
                let letterText = '<div id="letterText">'
                let footer = '<div id="footer">';
                function escapeRegExp(string) {
                    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                }

                let regexLetterText = new RegExp(`${escapeRegExp(letterText)}(.*?)${escapeRegExp(footer)}`, 's');
                let newStr = this.editorInstance.getContent();
                this.editorInstance.setContent(newStr.replace(regexLetterText, `${escapeRegExp(letterText)} ${content} ${escapeRegExp('</div>')} ${escapeRegExp(footer)}`));
            } else {
                this.editorInstance.setContent(content);
            }
        },

        addInfoPattern: function () {
            const content = '<h2 style="display: flex; align-items: center;"><img src="https://f.d-services.ru/web_assets/icon-info.png" alt="" style="max-width:100%;max-height:100%;vertical-align: middle;float: left"><strong style="max-width:600px;color:#0481D6;vertical-align: -webkit-baseline-middle;text-align: right;margin-left: 10px;">Заголовок</strong></h2><p>Введите текст</p>';
            if (this.editorInstance.getContent().includes('<div id="letterText">')) {
                let header = '<div id="header">';
                let letterText = '<div id="letterText">'
                let footer = '<div id="footer">';
                function escapeRegExp(string) {
                    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                }

                let regexLetterText = new RegExp(`${escapeRegExp(letterText)}(.*?)${escapeRegExp(footer)}`, 's');
                let newStr = this.editorInstance.getContent();
                this.editorInstance.setContent(newStr.replace(regexLetterText, `${escapeRegExp(letterText)} ${content} ${escapeRegExp('</div>')} ${escapeRegExp(footer)}`));
            } else {
                this.editorInstance.setContent(content);
            }
        },

        addHeaderAndFooter: function () {
            let header = '<div id="header">';
            let letterText = '<div id="letterText">'
            let footer = '<div id="footer">';
            function escapeRegExp(string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }
            let regexHeader = new RegExp(`${escapeRegExp(header)}(.*?)${escapeRegExp(footer)}`, 's');
            let regexFooter = new RegExp(`${escapeRegExp(footer)}(.*)`, 's');

            if (this.editorInstance.getContent().includes('<div id="header">') && this.editorInstance.getContent().includes('<div id="footer">')) {
                regexHeader = new RegExp(`${escapeRegExp(header)}(.*?)${escapeRegExp(letterText)}`, 's');

                let newStr = this.editorInstance.getContent()
                this.editorInstance.setContent(newStr.replace(regexHeader, `${header}${this.header}${'</div>'}${letterText}`))

                newStr = this.editorInstance.getContent()
                this.editorInstance.setContent(newStr.replace(regexFooter, `${footer}${this.footer}`))
            } else {
                this.editorInstance.setContent(`${header}${this.header}${'</div>'}${letterText}${'</div>'}${footer}${this.footer}`)
            }
        },

        newLetter: function () {
            location.reload();
        },
        editorSizing: function () {
            let tinymce = document.querySelector('iframe');
            let editor = tinymce.contentDocument || tinymce.contentWindow.document;
            editor.getElementById('tinymce').style.maxWidth = '600px';
            editor.getElementById('tinymce').style.margin = '0 auto';
        },
        nextKey() {
            if (this.keyIndex < this.tinymceKeys.length - 1) {
                this.keyIndex ++;

                localStorage.removeItem('keyIndex');
                localStorage.setItem('keyIndex', this.keyIndex);

                window.location.reload();
            } else {
                localStorage.removeItem('keyIndex');
                localStorage.setItem('keyIndex', 0);

                window.location.reload();
            }
        },
        getKeyIndex() {
            if (!localStorage.getItem('keyIndex')) {
                localStorage.setItem('keyIndex', 0);
            }
            this.keyIndex = localStorage.getItem('keyIndex');
        },
        validateKey() {
            const originalConsoleError = console.error;
            let setNextKey = this.nextKey.bind(this);

            console.error = function (...args) {
                if (args[0]?.includes("All created TinyMCE editors are configured to be read-only")) {
                    setNextKey();
                }
                originalConsoleError.apply(console, args);
            };
        }
    },
    created() {
        this.getKeyIndex();
        this.validateKey();
    },
    mounted () {
        this.getSenders();
    }
}

</script>

<style scoped lang="scss">
.page-label {
    font-size: 18px;
    font-weight: 600;
}
.or-label {
    font-weight: 500;
    padding-top: 24px;
}
.input-label {
    font-size: 14px;
    font-weight: 600;
}
.text-input-group {
    display: flex;
    flex-direction: row;
    gap: 60px;
}
.input-field {
    width: 400px;
    &__date {
        width: 300px;
    }
}
.schedule {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.v-select-input {
    display: flex;
    flex-direction: row;
    gap: 30px;
}
.v-select {
    width: 400px;
}
.letter_construct .pattern_container {
    display: block;
    position: absolute;
    top: 30px;
    left: 260px;
    background-color: #fff;
    border: 1px solid #D1D1D1;
    border-radius: 5px;
}

.letter_construct .pattern_inner {
    line-height: 38px;
    padding: 0 24px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
}

.letter_construct .pattern_inner:hover {
    background-color: #1aa2fd;
    color: #fff;
}

.letter_construct .editor_container {
    position: relative;
}

.template-add-controls {
    &__letter-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0px 0px 20px 0px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        margin: 20px 0px 20px 0px;
        gap: 18px;
        justify-content: space-between;
    }
}

.blue {
    color: #0678F4;
    font-size: 14px;
}

.black {
    color: black;
    font-size: 14px;
}

.left-side {
    display: flex;
    flex-direction: row;
    flex: 3;
}

.right-side {
    display: flex;
    flex-direction: row;
    flex: 2;
    justify-content: flex-end
}

#saveButton {
    padding: 0px 72px;
}

#previewButton {
    padding: 0px 30px;
}

#HTMLButton {
    padding: 0px 30px;
}

#cancelButton {
    padding: 0px 42px;
}

.mailing {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}

.selected-reciever {
    border: 1px solid #EAEEF4;
    border-radius: 5px;
    padding: 5px 8px;
    &__button {
        cursor: pointer;
    }
    &__button:hover {
        path {
            stroke: red;
            transition: stroke 0.15s ease;
        }
    }
}

</style>
